import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCreditCardNumberCommand extends BaseCommand {
  CommandName = "ChangeCreditCardNumber";
  Command: { Value: number | null };
  constructor(sessionId: string, operationId: string, value: number | null) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
